import sendGoogleTagEvent from '@hooks/useSendGoogleTagEvent';

/**
 * GA4 events for the add-job menu and its zmeu Task row.
 *
 * Both surfaces (desktop navbar menu, mobile bottom bar) fire the same event names
 * with a `surface` parameter, so the funnel can be read whole or split by device
 * without maintaining two sets of names. Kept next to the menu code rather than in
 * the components, so a name cannot be typed differently in one of the two places.
 */

/** Which menu the click came from. */
export type AddTaskSurface = 'navbar' | 'bottom_nav';

/** Which zmeu channel an icon opens. */
export type AddTaskChannel = 'call' | 'whatsapp';

/**
 * The add-job cell / trigger was tapped open. Only the mobile bar and the keyboard
 * path really "open" — desktop hover is not a click and stays untracked.
 */
export const trackAddMenuOpen = (surface: AddTaskSurface) => {
  sendGoogleTagEvent('nav_add_menu_open', 'Custom', { surface });
};

/**
 * A route into the add-job form was clicked. `placement` separates the navbar
 * trigger itself from the Job row inside the open menu.
 */
export const trackAddJobClick = (surface: AddTaskSurface, placement: 'trigger' | 'menu') => {
  sendGoogleTagEvent('nav_add_job_click', 'Custom', { surface, placement });
};

/** A zmeu channel icon was clicked — the actual task intent. */
export const trackAddTaskClick = (surface: AddTaskSurface, channel: AddTaskChannel) => {
  sendGoogleTagEvent('nav_add_task_click', 'Custom', { surface, channel });
};

/** The Task wording was clicked open, i.e. someone asked what zmeu is. */
export const trackAddTaskInfoOpen = (surface: AddTaskSurface) => {
  sendGoogleTagEvent('nav_add_task_info_open', 'Custom', { surface });
};
